import '../styles/app.scss';
import './_images';
import './hub.js';
import './donation-form.js';

document.addEventListener(
	'DOMContentLoaded',
	() => {
		console.log('App ready');
	},
	false
);
